import { render, staticRenderFns } from "./loginPass.vue?vue&type=template&id=15f6e954"
import script from "./loginPass.vue?vue&type=script&lang=js"
export * from "./loginPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports